import { render, staticRenderFns } from "./smsAll.vue?vue&type=template&id=5bf85922&scoped=true&"
import script from "./smsAll.vue?vue&type=script&lang=js&"
export * from "./smsAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf85922",
  null
  
)

export default component.exports